export const THEME_COLOR = "#00a1bd";
export const THEME_COLOR_LIGHT = "#e6f6f9";
export const WHITE = "#ffffff";
export const BLACK = "#000000";
export const YELLOW_LIGHTER = "#e2af2c66";
export const GRAY = "#aaa";
export const SUCC_COLOR = "#002944";
